import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, EffectCoverflow } from "swiper/modules";
import { useT } from "@/lib/i18n";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-coverflow";

interface Step {
  number: number;
  titleKey: string;
  descriptionKey: string;
}

const stepKeys: Step[] = [
  { number: 1, titleKey: "howItWorks.steps.step1.title", descriptionKey: "howItWorks.steps.step1.description" },
  { number: 2, titleKey: "howItWorks.steps.step2.title", descriptionKey: "howItWorks.steps.step2.description" },
  { number: 3, titleKey: "howItWorks.steps.step3.title", descriptionKey: "howItWorks.steps.step3.description" },
  { number: 4, titleKey: "howItWorks.steps.step4.title", descriptionKey: "howItWorks.steps.step4.description" },
  { number: 5, titleKey: "howItWorks.steps.step5.title", descriptionKey: "howItWorks.steps.step5.description" },
];

export const HowItWorks = ({ compact = false }: { compact?: boolean } = {}) => {
  const { t } = useT("landing");
  return (
    <div className="w-full mx-auto py-8">
      {/* Swiper Carousel */}
      <div className="relative swiper-container-custom" style={{ perspective: "1200px" }}>
        <Swiper
          modules={[Navigation, Pagination, EffectCoverflow]}
          effect="coverflow"
          grabCursor={true}
          centeredSlides={true}
          slidesPerView="auto"
          navigation={true}
          pagination={{
            clickable: true,
            dynamicBullets: false,
          }}
          coverflowEffect={{
            rotate: 0,
            stretch: 0,
            depth: 100,
            modifier: 1,
            slideShadows: false,
          }}
          className="py-8 px-12 pb-16"
        >
          {stepKeys.map((step) => (
            <SwiperSlide
              key={step.number}
              className={`!w-[85vw] md:!w-[320px] ${compact ? "min-h-[240px] md:min-h-[220px]" : "min-h-[400px] md:min-h-[380px]"}`}
            >
              {({ isActive, isPrev, isNext }) => (
                <div
                  className="h-full transition-all duration-300"
                  style={{
                    transform: `perspective(1200px) rotateY(${
                      isPrev ? "25deg" : isNext ? "-25deg" : "0deg"
                    })`,
                    opacity: isActive ? 1 : 0.7,
                  }}
                >
                  <div className={`card p-6 rounded-2xl shadow-lg ${compact ? "h-auto" : "h-[350px] md:h-[300px]"} flex flex-col`}>
                    {/* Number Badge */}
                    <div className="flex justify-center mb-4">
                      <div className="w-12 h-12 rounded-full bg-primary-500 text-white flex items-center justify-center text-xl font-bold shadow-md">
                        {step.number}
                      </div>
                    </div>

                    {/* Title */}
                    <h3 className="text-xl font-bold text-type-950 mb-3 text-center">
                      {t(step.titleKey)}
                    </h3>

                    {/* Description */}
                    <div className="text-dark-muted text-center text-sm leading-relaxed flex-1">
                      {t(step.descriptionKey)}
                    </div>
                  </div>
                </div>
              )}
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};
